import { useEffect } from 'react';
const PIXEL_ID = '2131397850775534';
type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & {
  fbq?: FbqFunction;
  _fbq?: FbqFunction;
};
function getFbq(): FbqFunction {
  const win = window as PixelWindow;
  if (win.fbq) return win.fbq;
  const fbq: FbqFunction = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue?.push(args);
    }
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  win.fbq = fbq;
  if (!win._fbq) win._fbq = fbq;
  return fbq;
}
export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  const win = window as PixelWindow;
  if (!win.fbq) return;
  win.fbq('track', event, params);
}
export function MetaPixel() {
  useEffect(() => {
    const fbq = getFbq();
    const scriptSrc = 'https://connect.facebook.net/en_US/fbevents.js';
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptSrc;
      document.head.appendChild(script);
    }
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-135" data-mp="1rech0a71jm92">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-136" data-mp="1rdudqtlyo7rn" />
    </noscript>;
}